/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Col_BrokerInputs */

const cs_ebr_col_broker = /** @type {(inputs: Ebr_Col_BrokerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_ebr_col_broker = /** @type {(inputs: Ebr_Col_BrokerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker`)
};

/**
* | output |
* | --- |
* | "Broker" |
*
* @param {Ebr_Col_BrokerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_col_broker = /** @type {((inputs?: Ebr_Col_BrokerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Col_BrokerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_col_broker(inputs)
	return cs_ebr_col_broker(inputs)
});